import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

export const useFormBuilderLdFlags = createFlagsHook<typeof import('./flags.json')>()
